import styles from './Social.module.css';

import ListItem from '../../UI/List/ListItem';
import UnorderedList from '../../UI/List/UnorderedList';

const Social = props => {
  return (
    <UnorderedList className={`${styles.socialList} ${props.className ? props.className : ''}`}>

      <ListItem className={styles.socialIcon}>
        <a href="https://twitter.com/ClonesDAO"
          target="_blank"
          rel="noreferrer">
          <i className="ri-twitter-line"></i>
        </a>
      </ListItem>

      <ListItem className={styles.socialIcon}>
        <a href="https://discord.gg/INSERT_DISCORD_LINK_HERE"
          target="_blank"
          rel="noreferrer">
          <i className="ri-discord-line"></i>
        </a>
      </ListItem>

    </UnorderedList>
  );
};

export default Social;